import { useMemo } from 'react'

import { getOfferImageId, getSavedDetailsForOffer } from 'tripPlanner/components/Bookmark/BookmarkButton/utils'
import { useEditableTrips } from 'tripPlanner/hooks/api/trip'
import { EmptyArray } from 'lib/array/arrayUtils'
import SavePrompt from './SavePrompt'
import useNewTripNameFromOffer from 'tripPlanner/hooks/useNewTripNameFromOffer'
import useShouldShowTripPlannerSaveEntryPoints from 'tripPlanner/hooks/useShouldShowTripPlannerSaveEntryPoints'
import type { TourBookmarkPayload } from 'tripPlanner/api/bookmark/types'
import type { BasicTrip } from 'tripPlanner/types/common'
import { isCruiseV1Offer } from 'lib/offer/offerTypes'

interface Props {
  offer: App.TourOffer | App.Tours.TourV2Offer
  selectedVariation?: App.Tours.TourV2OfferVariation
}

function SavePromptTour({ offer, selectedVariation }: Props) {
  const shouldShowTripPlannerSaveEntryPoints =
    useShouldShowTripPlannerSaveEntryPoints()
  const { data, isSuccess: tripsFetched } = useEditableTrips({
    enabled: shouldShowTripPlannerSaveEntryPoints,
  })
  const trips = data ?? EmptyArray as Array<BasicTrip>

  const details = getSavedDetailsForOffer(trips, offer.id)
  const isSaved = details.length > 0

  const newTripName = useNewTripNameFromOffer(
    offer,
    shouldShowTripPlannerSaveEntryPoints,
  )

  const bookmarkPayload = useMemo<TourBookmarkPayload>(() => ({
    type: offer.parentType,
    code: offer.id,
    subCode: selectedVariation?.fkTourOptionId,
  }), [offer, selectedVariation?.fkTourOptionId])

  if (!shouldShowTripPlannerSaveEntryPoints || isSaved || !tripsFetched) {
    return null
  }

  return <SavePrompt
    offerId={offer.id}
    offerTypeLabel={isCruiseV1Offer(offer) ? 'cruise' : 'tour'}
    bookmarkPayload={bookmarkPayload}
    newTripName={newTripName}
    offerImageId={getOfferImageId(offer)}
    trips={trips}
  />
}

export default SavePromptTour
